import eSendingMode from "~/enums/eSendingMode";
import isValidEmail from "~/utils/isValidEmail";

const isInvalidSendingMode = (email: string, phone: string, sendingMode: eSendingMode) =>
    (
        [eSendingMode.EMAIL, eSendingMode.EMAIL_AND_TEXT].includes(sendingMode) &&
        !isValidEmail(email)
    ) || (
        [eSendingMode.TEXT, eSendingMode.EMAIL_AND_TEXT].includes(sendingMode) &&
        !phone
    )

export default isInvalidSendingMode;